<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  تعاریف متنی گواهی‌نامه</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">کمیت/زیر کمیت</label>
        <input [(ngModel)]="Filter_quantity" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Definitionscertificate()" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button routerLink="/DefinitionscertificateAdd" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <button (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کمیت/زیر کمیت</th>
              <th>Calibration Method</th>
              <th>Uncertainty</th>
              <th>Traceability</th>
              <th>Decision Rule</th>
              <th>Code</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Definitionscertificate
            |filter:Filter_quantity:'quantity_title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Definitionscertificate|filter:Filter_quantity:'quantity_title').length
                      }
            ">
              <td>{{DataList_Definitionscertificate.indexOf(item)+1}}</td>
              <td>{{item.quantity_title}}</td>
              <td>{{item.cALIBRATIONMETHOD}}</td>
              <td>{{item.uNCERTAINTY}}</td>
              <td>{{item.tRACEABILITY}}</td>
              <td>{{item.decisionRule}}</td>
              <td>{{item.code}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>

              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4  class="modal-title pull-left">تایید حذف اطلاعات  تعاریف متنی گواهی‌نامه '{{Data_Seleted_Delete.quantity_title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button   type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;" >
  <thead >
    <tr>
      <th>#</th>
      <th>کمیت/زیر کمیت</th>
      <th>Calibration Method</th>
      <th>Uncertainty</th>
      <th>Traceability</th>
      <th>Decision Rule</th>
      <th>تاریخ</th>
      <th>کاربر</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Definitionscertificate|filter:Filter_quantity:'quantity_title'">
      <td>{{DataList_Definitionscertificate.indexOf(item)+1}}</td>
      <td>{{item.quantity_title}}</td>
      <td>{{item.cALIBRATIONMETHOD}}</td>
      <td>{{item.uNCERTAINTY}}</td>
      <td>{{item.tRACEABILITY}}</td>
      <td>{{item.decisionRule}}</td>
      <td>{{item.persianDate}}</td>
      <td>{{item.username}} </td>
    </tr>
  </tbody>
</table>
